
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var DateUtility = require("utils/DateUtility");


    var InvoicesModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        InvoicesModel = BaseModel.extend({
            name: "InvoicesModel",
            initialize: function(options) {
                this.resource= {};
                this.resource.url = ApiResources.Billing.Invoices.url.replace("{accountId}", LE.loginInfo.accountId);
            },
            parse: function(response, options){
                var invoices= _.map(response, function(invoice, key){
                    /*var dateParts= invoice.invoiceDate.split("-");
                    var year= parseInt(dateParts[0]);
                    var month= parseInt(dateParts[1]) - 1;
                    var day= parseInt(dateParts[2]);
                    var date= new Date(Date.UTC(year, month, day));*/
                    var date= DateUtility.strToDateObj(invoice.invoiceDate);
                    date= DateUtility.getDateToShow(date);
                    invoice.formatted= {
                        invoiceNumber: invoice.invoiceNumber,
                        invoiceDate: date,
                        amount: invoice.amount < 0 || invoice.refund ? ("-$" + Math.abs(invoice.amount.toFixed(2))) : ("$" + Math.abs(invoice.amount.toFixed(2))),
                        balance: invoice.balance < 0 ? ("-$" + Math.abs(invoice.balance.toFixed(2))) : ("$" + Math.abs(invoice.balance.toFixed(2)))
                    };
                    return invoice;
                });
                return invoices;
            }
        });
    });

    InvoicesModel.downloadInvoice= function(invoiceNumber){
        var url = ApiResources.Billing.InvoiceDownload.url.replace("{accountId}", LE.loginInfo.accountId);
        var csrf= LE.sessionManager.getGlob();
        url = ApiResources.Billing.InvoiceDownload.url.replace("{accessToken}", csrf);
        url = url.replace("{invoiceNumber}", invoiceNumber);
        url= LEResourceResolver.getUrl(url);

        if($('iframe[name=invoiceDownloader]').length > 0){
            $('iframe[name=invoiceDownloader]').attr("src",url)
            .load();
        }else{
            $('<iframe name="invoiceDownloader" src="'+url+'">')
            .load()
            .css({position: "absolute", left: "-10000px", top: "0px"})
            .appendTo(document.body);
        }
    };

    return InvoicesModel;
});

